import { createContext } from 'react';
import { UseChatReturn } from './hooks/useChat';

/** The chat API without the prompt, so typing doesn't re-render every consumer. */
export const ChatContext = createContext<UseChatReturn['chatApi'] | null>(null);

/** The draft prompt and what is derived from it. Changes on every keystroke by design. */
export const ChatQueryContext = createContext<UseChatReturn['chatQueryValue'] | null>(null);
